<template>
  <v-dialog v-model="isDialogOpened" width="620px" :fullscreen="$vuetify.breakpoint.smAndDown" scrollable>
    <v-card>
      <v-card-title class="primary white--text">
        <v-toolbar-title>CHI TIẾT CÔNG VIỆC</v-toolbar-title>
        <v-spacer />
        <v-icon color="white" @click="cancel">close</v-icon>
      </v-card-title>
      <v-card-text class="pa-4">
        <div class="task-title mb-4">
          {{ taskTitle }}
        </div>
        <div class="task-content mb-4">
          {{ taskContent }}
        </div>
        <div class="task-data mb-4">
          <div class="data-title">Người giao</div>
          <div class="member">
            {{ creatorName }}
          </div>
        </div>
        <div class="task-data mb-4">
          <div class="data-title">Người nhận</div>
          <div class="member">
            {{ receiverName }}
          </div>
        </div>
        <div v-if="startTime" class="task-data mb-4">
          <div class="data-title">Bắt đầu từ</div>
          {{ startTime }}
        </div>
        <div v-if="endTime" class="task-data mb-4">
          <div class="data-title">Kết thúc trước</div>
          {{ endTime }}
        </div>
        <div v-if="task.category === 'done'" class="task-data mb-4">
          <div class="data-title">Đánh giá</div>
          <div class="evaluation">
            {{ getEvaluation }}
          </div>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import { get, find } from 'lodash'
import moment from 'moment'
import mixins from '../helper/mixins'

export default {
  components: {},
  props: {},
  data() {
    return {
      isDialogOpened: false,
      task: {}
    }
  },
  computed: {
    ...mapState('task', ['tasks']),
    ...mapGetters('task', ['contributorsByID']),
    taskTitle() {
      return get(this.task, 'title', '')
    },
    taskContent() {
      return get(this.task, 'content', '')
    },
    creatorName() {
      const creatorID = get(this.task, 'creator.id', null)
      if (creatorID && this.contributorsByID[creatorID]) {
        return this.contributorsByID[creatorID].name
      }
      return ''
    },
    receiverName() {
      const receiverID = get(this.task, 'receiver.id', null)
      if (receiverID && this.contributorsByID[receiverID]) {
        return this.contributorsByID[receiverID].name
      }
      return ''
    },
    startTime() {
      const date = moment(get(this.task, 'startTime', ''))
      if (date.isValid()) {
        return date.format('DD/MM/YYYY')
      } else {
        return ''
      }
    },
    endTime() {
      const date = moment(get(this.task, 'endTime', ''))
      if (date.isValid()) {
        return date.format('DD/MM/YYYY')
      } else {
        return ''
      }
    },
    getEvaluation() {
      if (!this.task.evaluate) {
        return 'Chưa đánh giá'
      }
      if (this.task.evaluate >= 10) {
        return 'A+'
      } else if (this.task.evaluate >= 9) {
        return 'A'
      } else if (this.task.evaluate >= 8) {
        return 'A-'
      } else if (this.task.evaluate >= 7) {
        return 'B+'
      } else if (this.task.evaluate >= 6) {
        return 'B'
      } else if (this.task.evaluate >= 5) {
        return 'B-'
      } else if (this.task.evaluate >= 4) {
        return 'C+'
      } else if (this.task.evaluate >= 3) {
        return 'C'
      } else if (this.task.evaluate >= 2) {
        return 'C-'
      } else {
        return 'D'
      }
    }
  },
  methods: {
    cancel() {
      this.isDialogOpened = false
    },
    openDialog(taskID) {
      this.task = find(this.tasks, { id: taskID })
      if (this.task) {
        this.isDialogOpened = true
      }
    }
  },
  mixins: [mixins]
}
</script>

<style lang="scss" scoped>
.task-title {
  font-weight: bold;
}
.task-data {
  display: flex;
  align-items: center;
  justify-content: flex-start;

  .data-title {
    flex: 0 0 150px;
    padding: 4px 0;
  }
}

.member {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}
.chip {
  display: inline-block;
  padding: 4px 10px;
  background-color: #bbdefb;
  border-radius: 30px;
}
</style>
